module.exports = __webpack_public_path__ + "img/service-content-attendance@3x.41f1997b.png";